export enum AppRoutes {
  OVERVIEW = '/overview',
  TOKENS = '/tokens',
  PAIRS = '/pairs',
  PAIRS_DETAILS = '/pairs/:pair',
  TOKEN_DETAILS = '/tokens/:token',
  GOVERNANCE = '/governance',
  BAKER_DETAILS = '/governance/:baker',
  ACCOUNTS = '/accounts',
  ACCOUNT_DETAILS = '/accounts/:account',
  SAVED = '/saved',
  UI_KIT = '/ui-kit',
  NOT_FOUND = '/404',
  DIFFERENT_ROUTES = '*',
}
